import { render, staticRenderFns } from "./noPermissionsMessage.vue?vue&type=template&id=42ec05c1&scoped=true&"
import script from "./noPermissionsMessage.vue?vue&type=script&lang=js&"
export * from "./noPermissionsMessage.vue?vue&type=script&lang=js&"
import style0 from "./noPermissionsMessage.vue?vue&type=style&index=0&id=42ec05c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ec05c1",
  null
  
)

export default component.exports